/* import 'jquery';
import 'popper.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'angular-ui-router';
import 'oclazyload'
import './libs/angular-local-storage.min';
import angularAnimate from 'angular-animate';
import angularAria from 'angular-aria';
import angularMaterial from 'angular-material';
import 'angular-messages';
import toastr from 'toastr';
import ngMaterialDatePicker from 'ng-material-datetimepicker';
import ngFileUpload from 'ng-file-upload';
import 'ng-sortable'; */


/**
 * Load all 3rd party imports here so it'll be
 * directly included in vendor.bundle.js file.
 */

import 'angular'
import 'jquery';
import 'oclazyload'
import 'popper.js';
import './libs/angular-local-storage.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'angular-ui-router';
import 'toastr'
import 'angular-animate';
import 'angular-aria';
import 'angular-material';
import 'angular-messages';
import 'ng-sortable';
import 'ng-material-datetimepicker';
import 'ng-img-crop/compile/minified/ng-img-crop.js';
import 'ng-file-upload';
//import 'underscore';
import 'jspdf';
import 'angularjs-slider';
import 'jquery-easyui/js/jquery.easyui.min';

import './libs/fullcalendar.min.js';
import './libs/calendar.min.js';

// import 'jquery-easyui/js/jquery.easyui.min.js';
import 'print-js'
import 'textangular';
import 'textangular/dist/textAngular-sanitize';
import 'textangular/dist/textAngularSetup';
import 'angular-clock';
import './libs/jquery.vticker-min';
import './libs/angular-send-feedback';
import './libs/collapsibleDirective.min.js';
toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": true,
    "onclick": null,
    "showDuration": "4000",
    "hideDuration": "1000",
    "timeOut": "2000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}



// WEBPACK FOOTER //
// ./src/vendor.module.js